import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi";
import { GoCopy } from "react-icons/go";

function Contact() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText("taruntalan12@gmail.com").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Container fluid id="contact" className="contact-section">
      <Container>
        <Row style={{ paddingTop: "80px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social text-center">
            <h5 className="contact-section-label">Initiate Connection</h5>
            <h1 className="contact-heading">Let's <span className="purple">Connect</span></h1>
            
            <Row className="justify-content-center">
              {/* Card 1: Email */}
              <Col xs={12} sm={6} md={3} className="d-flex mb-4">
                <div 
                  className="contact-card"
                  onClick={handleCopyEmail}
                >
                  {copied && (
                    <div className="contact-card-copied-banner">
                      COPIED!
                    </div>
                  )}
                  <div className="contact-card-top">
                    <div className="contact-card-icon-container">
                      <AiFillMail />
                    </div>
                    <FiArrowUpRight className="contact-card-arrow" />
                  </div>
                  <div className="contact-card-middle">
                    <h3 className="contact-card-title">Email</h3>
                    <p className="contact-card-value">taruntalan12@gmail.com</p>
                  </div>
                  <div className="contact-card-footer">
                    <GoCopy /> COPY TO CLIPBOARD
                  </div>
                </div>
              </Col>

              {/* Card 2: LinkedIn */}
              <Col xs={12} sm={6} md={3} className="d-flex mb-4">
                <a 
                  className="contact-card"
                  href="https://www.linkedin.com/in/tarun-talan-77360a37a/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="contact-card-top">
                    <div className="contact-card-icon-container">
                      <FaLinkedinIn />
                    </div>
                    <FiArrowUpRight className="contact-card-arrow" />
                  </div>
                  <div className="contact-card-middle">
                    <h3 className="contact-card-title">LinkedIn</h3>
                    <p className="contact-card-value">in/tarun-talan-77360a37a</p>
                  </div>
                  <div className="contact-card-footer">
                    CONNECT & CHAT
                  </div>
                </a>
              </Col>

              {/* Card 3: GitHub */}
              <Col xs={12} sm={6} md={3} className="d-flex mb-4">
                <a 
                  className="contact-card"
                  href="https://github.com/TarunTalan"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="contact-card-top">
                    <div className="contact-card-icon-container">
                      <AiFillGithub />
                    </div>
                    <FiArrowUpRight className="contact-card-arrow" />
                  </div>
                  <div className="contact-card-middle">
                    <h3 className="contact-card-title">GitHub</h3>
                    <p className="contact-card-value">github.com/TarunTalan</p>
                  </div>
                  <div className="contact-card-footer">
                    EXPLORE REPOSITORIES
                  </div>
                </a>
              </Col>

              {/* Card 4: Twitter */}
              <Col xs={12} sm={6} md={3} className="d-flex mb-4">
                <a 
                  className="contact-card"
                  href="https://twitter.com/taruntalan01"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="contact-card-top">
                    <div className="contact-card-icon-container">
                      <AiOutlineTwitter />
                    </div>
                    <FiArrowUpRight className="contact-card-arrow" />
                  </div>
                  <div className="contact-card-middle">
                    <h3 className="contact-card-title">Twitter</h3>
                    <p className="contact-card-value">@taruntalan01</p>
                  </div>
                  <div className="contact-card-footer">
                    FOLLOW & MESSAGE
                  </div>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;
